<script>
export default {
  name: 'LegacyCashbackPill',
  props: {
    text: { type: [String, Number], default: '' },
    type: { type: String, default: 'FIXED' },
    currency: { type: String, default: '' },
    max: { type: [String, Number], default: null },
  },
  computed: {
    // PERCENTAGE_MAX is a percentage value with a fixed cap held separately — its
    // amount is a percentage, not a currency figure, so it renders like PERCENTAGE.
    isPercentage() {
      return this.type === 'PERCENTAGE' || this.type === 'PERCENTAGE_MAX'
    },
    suffix() {
      return this.isPercentage ? '%' : ''
    },
    prefix() {
      return this.isPercentage ? '' : this.currency || ''
    },
  },
}
</script>

<template>
  <span
    class="inline-flex items-center rounded-md border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-xs font-semibold text-emerald-800 whitespace-nowrap"
  >
    {{ prefix }}{{ text }}{{ suffix }}
    <span v-if="max" class="ml-1 font-normal text-emerald-700">(max {{ currency }}{{ max }})</span>
  </span>
</template>
